import { useCallback } from 'react';
import { useBackgroundNavigate } from '@shared/hooks';
import { useCustomsTasksTableColumns } from './use-customs-tasks-table-columns';

export const useCustomsTasksTable = () => {
  const columns = useCustomsTasksTableColumns();
  const navigate = useBackgroundNavigate();

  const getRowProps = useCallback(
    (id: number | string) => ({
      onDoubleClick: () => navigate(`/customs/tasks/${id}`, { withBackground: false }),
    }),
    [navigate],
  );

  return { columns, getRowProps };
};
